import { faKey } from '@fortawesome/pro-regular-svg-icons';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ViewRecoveryCodesForm from '../../ViewRecoveryCodesForm';
import MfaRecovery from '../MfaRecovery';

export default function MfaRecoveryCodes() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <MfaRecovery
        icon={faKey}
        name={<FormattedMessage id="mfa_recovery_codes" />}
        description={<FormattedMessage id="mfa_recovery_codes_description" />}
        onView={() => setOpen(true)}
      />
      <CustomDialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <ViewRecoveryCodesForm onClose={() => setOpen(false)} />
      </CustomDialog>
    </>
  );
}
